var exports = {
  "M": "tab-YXkyM",
};

module.exports = exports;
